module.exports = __webpack_public_path__ + "static/media/about-image.00b640d3.jpg";